var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16075_38420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.03 4.09622C13.2896 3.83642 13.7108 3.83642 13.9704 4.09622C14.9342 5.06006 15.4079 6.40275 15.2703 7.78024C15.2359 8.1234 14.9468 8.3792 14.6092 8.3792C14.587 8.3792 14.5647 8.37808 14.5425 8.37586C14.177 8.3393 13.9103 8.01319 13.9469 7.64788C14.0448 6.66896 13.7105 5.7171 13.03 5.03655C12.7702 4.77699 12.7702 4.35578 13.03 4.09622Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3965 0C14.5891 0 18 3.41089 18 7.60345C18 11.796 14.5891 15.2069 10.3965 15.2069C6.20399 15.2069 2.79309 11.796 2.79309 7.60345C2.79309 3.41089 6.20402 0 10.3965 0ZM10.3965 13.8768C13.8558 13.8768 16.6699 11.0627 16.6699 7.60345C16.6699 4.14422 13.8558 1.33007 10.3965 1.33007C6.93752 1.33007 4.12316 4.14422 4.12316 7.60345C4.12316 11.0627 6.93731 13.8768 10.3965 13.8768Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.195345 16.8648L5.02788 12.0323C5.28768 11.7725 5.70843 11.7725 5.96823 12.0323C6.22804 12.2919 6.22804 12.713 5.96823 12.9726L1.1357 17.8051C1.0058 17.935 0.835785 18 0.665524 18C0.495262 18 0.325247 17.935 0.195345 17.8051C-0.0644236 17.5455 -0.0644236 17.1244 0.195345 16.8648Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16075_38420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.52d291c423c95dafc92f24773376525d.svg";
export { ForwardRef as ReactComponent };